import { initLayout } from '@catawiki/layout';

import type { PagesRuntimeConfig } from './runtimeConfig';

let initialized = false;

export function initializeLayout(runtimeConfig: PagesRuntimeConfig) {
  if (typeof window === 'undefined' || initialized) return;
  // A client transition from a bare page needs the server-owned head and runtime identifiers.
  if (!document.head.querySelector('[data-layout-source="head-tags"]')) {
    window.location.reload();
    return;
  }
  initialized = true;
  initLayout({
    kustomer: {
      token: runtimeConfig.kustomerApiKey,
      defaultAssistantId: runtimeConfig.kustomerDefaultAssistantId,
    },
  });
}
